"use client";

import { useEffect } from 'react';

const RevealElement = ({ children, className }: { children: any, className?: any }) => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('opacity-100');
          entry.target.classList.add('!translate-y-0');
          entry.target.classList.add('delay-300');
        }
      });
    });

    const revealElements = document.querySelectorAll('.reveal-anim');
    revealElements.forEach((element) => {
      observer.observe(element);
    });

    return () => observer.disconnect(); // Cleanup function
  }, []);

  return <div className={`reveal-anim duration-500 opacity-0 translate-y-6 ${className}`}>{children}</div>;
};

export default RevealElement;
